$component-class: 'call-to-action-type-11';

.#{$component-class} {
  me-row.#{$component-class}__content {
    position: relative;
    overflow: hidden;
    display: block;
    border: var(--border-size-sm) solid var(--border-color-primary);
  }

  .with-bg &__media {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
    pointer-events: none;

    & .#{$component-class}__overlay {
      position: absolute;
      inset: 0;
      background: rgb(60 60 60 / 70%);
      z-index: 1;
    }

    & > me-video[slot='background'],
    & > me-picture[slot='background'],
    & > me-picture[slot='background'] img,
    & .picture {
      width: 100%;
      height: 100%;
      display: block;
    }

    & > me-picture[slot='background'] img {
      object-fit: cover;
    }
  }

  &__intro {
    position: relative;
    z-index: 2;
    padding: var(--spacing-xl);

    @include desktop {
      padding: var(--spacing-5xl);
    }

    [slot='heading'] {
      .me-heading {
        margin-bottom: var(--spacing-lg);
        text-align: center;

        @include desktop {
          margin-bottom: var(--spacing-xl);
        }
      }
    }

    [slot='description'] {
      .me-text {
        margin-bottom: var(--spacing-xl);
        text-align: center;

        @include text-style('md', 'md');

        @include desktop {
          margin-bottom: var(--spacing-2xl);

          @include text-style('lg', 'md');
        }
      }
    }
  }
}

.me-column--hidden {
  display: none;
}
